export const lineColours = {
  0: '#12aa9d',
  1: '#91ad3d',
  2: '#82cb9d',
  3: '#cccc9d',
  4: '#82cd9d',
  5: '#82ce9d',
  6: '#82cg9d',
  7: '#82c09d',
  8: '#82c29d',
  9: '#82ca9d',
  10: '#82ca9d',
  11: '#82ca9d',
  12: '#82ca9d',
  13: '#82ca9d',
  14: '#82ca9d',
  15: '#82ca9d',
  16: '#82ca9d',
  17: '#82ca9d',
  18: '#82ca9d',
  19: '#82ca9d',
  20: '#82ca9d'
};

export const TIME_PRESETS = {
  hour: {
    name: '1h',
    number: 1
  },
  twelveHours: {
    name: '12h',
    number: 12
  },
  twentyFourHours: {
    name: '24h',
    number: 24
  },
  fortyEightHours: {
    name: '48h',
    number: 48
  },
  free: {
    name: 'free',
    number: '0'
  }
};

export const SENSORS = {
  Power: { name: 'Power', unit: 'kW' },
  Temperature: { name: 'Temperature', unit: '°C' },
  Voltage: { name: 'Voltage', unit: 'V' },
  Current: { name: 'Current', unit: 'A' },
  InternalResistance: {
    name: 'InternalResistance',
    unit: 'R'
  },
  MinCellVoltage: {
    name: 'MinCellVoltage',
    unit: 'V'
  },
  MaxModuleTemperature: {
    name: 'MaxModuleTemperature',
    unit: '°C'
  },
  MinModuleTemperature: {
    name: 'MinModuleTemperature',
    unit: '°C'
  },
  SOC: {
    name: 'SOC',
    unit: '%'
  },
  SystemCapacity: {
    name: 'SystemCapacity',
    unit: 'unknown'
  },
  MaxCellVoltage: {
    name: 'MaxCellVoltage',
    unit: 'V'
  },
  AverageCellVoltage: {
    name: 'AverageCellVoltage',
    unit: 'V'
  },
  MaxCellTemperature: {
    name: 'MaxCellTemperature',
    unit: '°C'
  },
  MinCellTemperature: {
    name: 'MinCellTemperature',
    unit: '°C'
  },
  AverageCellTemperature: {
    name: 'AverageCellTemperature',
    unit: '°C'
  },
  MinBalanceRate: {
    name: 'MinBalanceRate',
    unit: 'unknown'
  },
  MaxBalanceRate: {
    name: 'MaxBalanceRate',
    unit: 'unknown'
  },
  AverageBalanceRate: {
    name: 'AverageBalanceRate',
    unit: 'unknown'
  }
};

export const moduleTemplateKeysDict = {
  id: 'Id',
  carModel: 'Car model',
  moduleType: 'Module type',
  batteryCellManufacturer: 'Battery cell manufacturer',
  chemistryType: 'Chemistry type',
  cellType: 'Cell type',
  cellNominalVoltage: 'Cell nominal voltage',
  cellNominalCapacity: 'Cell nominal capacity',
  cellNominalResistance: 'Cell nominal resistance',
  moduleNominalVoltage: 'Module nominal voltage',
  moduleNominalResistance: 'Module nominal resistance',
  moduleNominalCapacity: 'Module nominal capacity',
  productionStartYear: 'Production start year',
  productionEndYear: 'Production end year',
  packCapacity: 'Pack capacity'
};

export const repackOrganizationId = 'd7f0b5d3-17ae-4bbc-a2b2-4da53cdadb32';
